import { useEffect, useState } from 'react';

export const useKlarysOuvert = () => {
  const [ouvert, setOuvert] = useState(document.body.dataset.klarys === 'ouvert');
  useEffect(() => {
    const obs = new MutationObserver(() => setOuvert(document.body.dataset.klarys === 'ouvert'));
    obs.observe(document.body, { attributes: true, attributeFilter: ['data-klarys'] });
    return () => obs.disconnect();
  }, []);
  return ouvert;
};
